<template>
 
  <PvDialog id="add-org-dialog"  v-model:visible="visible" modal :style="{ width: '75%' }" :closable="false" aria-labelledby="add-org-caption">
    <template #header>
      <h2 id="add-org-caption">{{ dialogCaption }}</h2>
    </template>
    <AddOrganization ref="addAffiliateRef"
                     :organizationId="editOrganizationId" 
                     :parentOrganizationId=addOrganizationParentId 
                     :parentOrganizationType=addOrganizationParentType
                     @data-saved="handleDialogCloased(true)"
                     @data-canceled="handleDialogCloased(false)" />
    <template #footer>
      <div class="d-flex justify-content-end pt-2">
        <PvButton type="button" class="me-2" rounded @click="handleAffiliateCanceled" label="Cancel" severity="secondary" />
        <PvButton type="button" :label="saveButtonCaption" rounded @click="handleAffiliateSaved" />
      </div>
    </template>
  </PvDialog>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref, defineModel, watch, nextTick } from 'vue';

// Components
import AddOrganization from './AddOrganization.vue';

// Composables


// Stores


// Constants and Utils
import { focusFirstEnabledInput } from '@/utils/pageUtils';

// ===============================
// PROPS & EMITS
// ===============================
defineProps({
    editOrganizationId: {
        type: [Number, String, null],
        default: null
    },
    addOrganizationParentId: {
        type: [Number, String, null],
        default: null
    },
    addOrganizationParentType: {
        type: [String, null],
        default: null
    },
    dialogCaption: {
        type: String,
        default: 'Add Affiliate Organization'
    },
    saveButtonCaption: {
        type: String,
        default: 'Save Affiliate'
    }
});

const visible = defineModel('visible', {
    type: Boolean,
    default: false
});

const emit = defineEmits(['refreshOrganization']);

// ===============================
// COMPOSABLES & STORES
// ===============================


// ===============================
// REACTIVE STATE
// ===============================
const addAffiliateRef = ref(null);

// ===============================
// CONSTANTS
// ===============================


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const handleDialogCloased = async (dataSaved) => {
  if (dataSaved) {
    emit('refreshOrganization');
  }

  visible.value = false;
};

const handleAffiliateSaved = () => {
  addAffiliateRef.value?.onSubmit();
};

const handleAffiliateCanceled = () => {
  visible.value = false;
};


// ===============================
// WATCHERS
// ===============================
watch(visible, async (newVal) => {
  if (newVal) {
    await nextTick(() => {
      setTimeout(() => {
        focusFirstEnabledInput('add-org-dialog');
      }, 300);
    });
  }
});

// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>

</style>